import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { jsx as _jsx } from "react/jsx-runtime";
export const RemoveDomainFromTitleView = ({
  auditResult,
  editorApi
}) => {
  const {
    track
  } = useTracker();
  const handleTrackAction = () => {
    track('clickedFixLink', {
      recommendationType: SeoRecommendations.REMOVE_DOMAIN_FROM_TITLE
    });
  };
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "remove-domain-from-title-rec",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.REMOVE_DOMAIN_FROM_TITLE"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.REMOVE_DOMAIN_FROM_TITLE"
    }),
    status: auditResult.status,
    action: editorApi.removeDomainFromTitle,
    actionButtonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.actions.REMOVE_DOMAIN_FROM_TITLE"
    }),
    onTrackAction: handleTrackAction
  });
};